// src/utils/logger.js
const isDevelopment = process.env.REACT_APP_NODE_ENV === 'development';
const isTest = process.env.REACT_APP_NODE_ENV === 'local';

class Logger {
  constructor() {
    this.shouldLog = isDevelopment || isTest;
  }

  error(...args) {
    if (this.shouldLog) {
      console.error(...args);
    }
    // In production, you might want to send to error tracking
    // this.sendToErrorService('error', args);
  }

  warn(...args) {
    if (this.shouldLog) {
      console.warn(...args);
    }
  }

  log(...args) {
    if (this.shouldLog) {
      console.log(...args);
    }
  }

  info(...args) {
    // Always show info messages (important for users)
    console.info(...args);
  }

  debug(...args) {
    if (this.shouldLog) {
      console.debug(...args);
    }
  }

  // Special method for production errors that should be tracked
  criticalError(error, context = {}) {
    if (this.shouldLog) {
      console.error('Critical Error:', error, context);
    }
    // Send to error tracking service in production
    // this.sendToErrorService('critical', { error, context });
  }
}

export const logger = new Logger();
export default logger;

